import React from "react";

function CustomControlNew({props, state, methods}) {
    const label =
        state.values &&
        state.values.length > 0 &&
        state.values[0] &&
        state.values[0]["label"]
            ? state.values[0]["label"].split('\n')[0]
            : props.placeholder;
    return (
        <div className="select_control_container" onClick={() => methods.dropDown('toggle')}>
            <span>{label}</span>
        </div>
    );
}

export default CustomControlNew;



